/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S15_P1Inputs */

const tr_mesafeli_s15_p1 = /** @type {(inputs: Mesafeli_S15_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pandemi, savaş, doğal afet, altyapı kesintisi, internet servis sağlayıcı arızası, siber saldırı, yasal düzenleme değişikliği ve benzeri Tarafların kontrolü dışındaki olaylar mücbir sebep olarak kabul edilir. Bu durumlarda Tarafların sorumlulukları askıya alınır; mücbir sebebin 60 günü aşması halinde Taraflar Sözleşme'yi tek taraflı feshedebilir.`)
};

const en_mesafeli_s15_p1 = /** @type {(inputs: Mesafeli_S15_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pandemic, war, natural disaster, infrastructure outage, internet service provider failure, cyber attack, change of legal regulation and similar events beyond the control of the Parties are deemed force majeure. In such cases the obligations of the Parties are suspended; if the force majeure exceeds 60 days, the Parties may terminate the Agreement unilaterally.`)
};

const de_mesafeli_s15_p1 = /** @type {(inputs: Mesafeli_S15_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pandemie, Krieg, Naturkatastrophe, Infrastrukturausfall, Störung beim Internetdienstanbieter, Cyberangriff, Änderung gesetzlicher Regelungen und ähnliche Ereignisse außerhalb der Kontrolle der Parteien gelten als höhere Gewalt. In diesen Fällen werden die Pflichten der Parteien ausgesetzt; dauert die höhere Gewalt länger als 60 Tage, können die Parteien den Vertrag einseitig kündigen.`)
};

const ru_mesafeli_s15_p1 = /** @type {(inputs: Mesafeli_S15_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пандемия, война, стихийное бедствие, сбой инфраструктуры, авария у интернет-провайдера, кибератака, изменение правового регулирования и подобные события вне контроля Сторон признаются обстоятельствами непреодолимой силы. В таких случаях обязанности Сторон приостанавливаются; если обстоятельства непреодолимой силы длятся более 60 дней, Стороны вправе расторгнуть Договор в одностороннем порядке.`)
};

/**
* | output |
* | --- |
* | "Pandemic, war, natural disaster, infrastructure outage, internet service provider failure, cyber attack, change of legal regulation and similar events beyond..." |
*
* @param {Mesafeli_S15_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s15_p1 = /** @type {((inputs?: Mesafeli_S15_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S15_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s15_p1(inputs)
	if (locale === "de") return de_mesafeli_s15_p1(inputs)
	if (locale === "ru") return ru_mesafeli_s15_p1(inputs)
	return tr_mesafeli_s15_p1(inputs)
});